import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AuthInfo, AuthStatus, GENERIC_AUTH_SERVICE_TOKEN, GenericAuthService } from '@nk/auth-lib';
import { AppService } from '@nk/access-block';
import { AppIdentityCompositeEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { CachingService } from '@nk/caching-lib';

@Component({
  selector: 'nk-company-report-identity-override',
  templateUrl: './company-report-identity-override.component.html',
  styleUrls: ['./company-report-identity-override.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CompanyReportIdentityOverrideComponent implements OnInit {
  public authOverrideForm = new UntypedFormGroup({
    accessToken: new UntypedFormControl(''),
    redirectPath: new UntypedFormControl(''),
    customerSlug: new UntypedFormControl(''),
  });
  public auth: AuthInfo;
  public identity: AppIdentityCompositeEntity;
  public error: unknown;
  public currentAuthInfo$: Observable<AuthInfo>;

  constructor(
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
    private _appService: AppService,
    private _cdr: ChangeDetectorRef,
    private _router: Router,
    private _cachingService: CachingService,
  ) {}

  public ngOnInit(): void {
    this.currentAuthInfo$ = this._authService.authInfo$;
  }

  private _createAuthInfo(accessToken: string): AuthInfo {
    const now = new Date().getTime();
    const defaultExpir = 86400;
    const expiresAt = JSON.stringify(now + defaultExpir * 1000);
    const createdAt = JSON.stringify(now);

    return new AuthInfo(
      AuthStatus.Authenticated,
      expiresAt,
      createdAt,
      accessToken,
      null,
      null,
      'User is authenticated.',
    );
  }

  private _setNewAuth(accessToken: string, customerSlug: string, redirectPath: string) {
    const newAuthInfo = this._createAuthInfo(accessToken);
    console.info('set customer slug', customerSlug);
    this._authService.setCustomerSlug(customerSlug);
    this._authService.authInfo = newAuthInfo;
    this._authService.overrideToken(newAuthInfo);
    this._cachingService.invalidateAllCache();

    this._router.navigate([redirectPath]);
  }

  public setAuth() {
    this._setNewAuth(
      this.authOverrideForm.value['accessToken'],
      this.authOverrideForm.value['customerSlug'],
      this.authOverrideForm.value['redirectPath'],
    );
  }
}
